export function stringifyParams(params) {
  if (!params) return '';
  var parts = Object.keys(params).sort().map(function (k) {
    var v = JSON.stringify(params[k]);
    return "".concat(JSON.stringify(k), ":").concat(v);
  });
  return "{".concat(parts.join(','), "}");
}